
    import './styles.scoped.css';
    export default {
  "content": "awsui_content_vjswe_1huu1_66",
  "button": "awsui_button_vjswe_1huu1_70",
  "variant-normal": "awsui_variant-normal_vjswe_1huu1_131",
  "disabled": "awsui_disabled_vjswe_1huu1_152",
  "variant-primary": "awsui_variant-primary_vjswe_1huu1_160",
  "variant-link": "awsui_variant-link_vjswe_1huu1_189",
  "variant-icon": "awsui_variant-icon_vjswe_1huu1_218",
  "variant-inline-icon": "awsui_variant-inline-icon_vjswe_1huu1_247",
  "variant-inline-icon-pointer-target": "awsui_variant-inline-icon-pointer-target_vjswe_1huu1_276",
  "variant-inline-link": "awsui_variant-inline-link_vjswe_1huu1_305",
  "variant-modal-dismiss": "awsui_variant-modal-dismiss_vjswe_1huu1_338",
  "variant-flashbar-icon": "awsui_variant-flashbar-icon_vjswe_1huu1_367",
  "variant-breadcrumb-group": "awsui_variant-breadcrumb-group_vjswe_1huu1_396",
  "variant-menu-trigger": "awsui_variant-menu-trigger_vjswe_1huu1_430",
  "grouped": "awsui_grouped_vjswe_1huu1_459",
  "grouped-horizontal-first": "awsui_grouped-horizontal-first_vjswe_1huu1_468",
  "grouped-horizontal-middle": "awsui_grouped-horizontal-middle_vjswe_1huu1_472",
  "grouped-horizontal-last": "awsui_grouped-horizontal-last_vjswe_1huu1_478",
  "grouped-vertical-first": "awsui_grouped-vertical-first_vjswe_1huu1_482",
  "grouped-vertical-middle": "awsui_grouped-vertical-middle_vjswe_1huu1_486",
  "grouped-vertical-last": "awsui_grouped-vertical-last_vjswe_1huu1_492",
  "grouped-end-action-horizontal-last": "awsui_grouped-end-action-horizontal-last_vjswe_1huu1_496",
  "grouped-end-action-horizontal-only": "awsui_grouped-end-action-horizontal-only_vjswe_1huu1_496",
  "grouped-end-action-vertical-first": "awsui_grouped-end-action-vertical-first_vjswe_1huu1_500",
  "grouped-end-action-vertical-last": "awsui_grouped-end-action-vertical-last_vjswe_1huu1_500",
  "grouped-end-action-vertical-only": "awsui_grouped-end-action-vertical-only_vjswe_1huu1_500",
  "button-no-text": "awsui_button-no-text_vjswe_1huu1_576",
  "button-no-wrap": "awsui_button-no-wrap_vjswe_1huu1_580",
  "full-width": "awsui_full-width_vjswe_1huu1_583",
  "button-compact": "awsui_button-compact_vjswe_1huu1_600",
  "icon-left": "awsui_icon-left_vjswe_1huu1_610",
  "icon-right": "awsui_icon-right_vjswe_1huu1_615",
  "icon": "awsui_icon_vjswe_1huu1_610",
  "link": "awsui_link_vjswe_1huu1_634",
  "disabled-with-reason": "awsui_disabled-with-reason_vjswe_1huu1_634"
};
  